<template>
  <div>
    <h3 class="modal-title"> FORMULA </h3>

    <b-form-group :class="{'error-input' : $v.data_formula.title.$error}">
      <label> Formula Title </label>
      <j-input
        v-model="$v.data_formula.title.$model"
        :max-length="255"
        placeholder="Formula Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.data_formula.form.$error}">
      <label> Select Form </label>
      <j-single-select
        v-model="$v.data_formula.form.$model"
        :load-options="loadOptionsForm"
        :is-async="true"
        :cache-option="false"
        :placeholder="'Choose Form'"
        value-format="object"
        label="name"/>
    </b-form-group>
    <b-form-group v-if="formulaId">
      <!-- <b-form-group> -->
      <label> Formula </label>
      <div class="card-field-container">
        <div
          v-for="(variable, index) in data_variable"
          :key="variable.id"
          class="card-field-container">
          <label> Variable {{ index+1 }} </label>
          <i
            v-if="data_variable.length > 1"
            class="fa fa-times close-button"
            @click="deleteVariable(index)"/>
          <b-row v-if="variable.isDisabled">
            <b-col cols="12">
              {{ variable.source.id === 2 ? `(${variable.source_value.text})` :
              variable.source_value }}
              {{ variable.operand.text }}
              {{ variable.righthand === 2 ? variable.righthand_value.text :
              variable.righthand_value }}
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="4">
              <j-single-select
                v-model="variable.source"
                :options="sourceOptions(index)"
                :disabled="variable.isDisabled"
                value-format="object"
                placeholder="Choose Source"
                @input="openModal(index, 'source')"/>
            </b-col>
            <b-col cols="4">
              <button
                v-if="!variable.modeSelectOperand"
                :class="buttonStyle(variable.source_value && variable.source)"
                :disabled="!variable.source_value || !variable.source"
                @click="addOperand(index)">
                + Add Operation
              </button>
              <j-single-select
                v-if="variable.modeSelectOperand"
                v-model="variable.operand"
                :options="list_operand"
                :disabled="variable.isDisabled"
                value-format="object"
                placeholder="Choose Operand"/>
            </b-col>
            <b-col cols="4">
              <button
                v-if="!variable.modeSelectRighthand && variable.operand"
                :class="buttonStyle(variable.operand)"
                :disabled="!variable.operand"
                @click="addRighthand(index)">
                + Add Source
              </button>
              <j-single-select
                v-if="variable.modeSelectRighthand"
                v-model="variable.righthand"
                :options="sourceOptions(index)"
                :disabled="variable.isDisabled"
                value-format="object"
                placeholder="Choose Source"
                @input="openModal(index, 'righthand')"/>
            </b-col>
          </b-row>
          <button
            v-if="variable.isDisabled"
            class="btn btn-add-additional-info"
            @click="editVariable(index)">
            Edit Variable
          </button>
          <b-button
            v-if="variableOn(index)"
            class="btn blue"
            @click="saveVariable(index)">
            Add
          </b-button>
        </div>
        <button
          class="btn btn-add-additional-info"
          @click="addVariable">
          + Add Variable
        </button>
      </div>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeFormula">
            Close
          </b-button>
          <b-button
            v-if="!formulaId"
            class="btn blue"
            @click="saveFormula">
            Next
          </b-button>
          <b-button
            v-if="formulaId && !modeEdit"
            class="btn blue"
            @click="finishFormula">
            Finish
          </b-button>
          <b-button
            v-if="formulaId && modeEdit"
            class="btn blue"
            @click="finishFormula">
            Update
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal
      ref="modalSelectVariableSource"
      class="mod-form"
      centered>
      <b-form-group>
        <label> Select Source </label>
        <j-single-select
          v-if="modeValue === 'source'"
          v-model="data_variable[selectedIndex].source"
          :options="sourceOptions(selectedIndex)"
          value-format="object"
          placeholder="Choose Source"/>
        <j-single-select
          v-if="modeValue === 'righthand'"
          v-model="data_variable[selectedIndex].righthand"
          :options="sourceOptions(selectedIndex)"
          value-format="object"
          placeholder="Choose Source"/>
      </b-form-group>
      <b-form-group>
        <label> Value </label>
        <j-input
          v-if="modeValue === 'source' && !isResult"
          v-model="data_variable[selectedIndex].source_value"
          type="number"
          placeholder="Input Value"/>
        <j-single-select
          v-else-if="modeValue === 'source' && isResult"
          v-model="data_variable[selectedIndex].source_value"
          :options="list_result"
          value-format="object"
          placeholder="Choose Result"/>
        <j-input
          v-else-if="modeValue === 'righthand' && !isResult"
          v-model="data_variable[selectedIndex].righthand_value"
          type="number"
          placeholder="Input Value"/>
        <j-single-select
          v-else-if="modeValue === 'righthand' && isResult"
          v-model="data_variable[selectedIndex].righthand_value"
          :options="list_result"
          value-format="object"
          placeholder="Choose Result"/>
      </b-form-group>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn gray m__r--5"
              @click="closeSelectSource">
              Close
            </b-button>
            <b-button
              class="btn blue"
              @click="closeSelectSource">
              Save
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_formula: {
      title: {
        required,
      },
      form: {
        required,
      },
      formulaOperationIds: {
        required,
      },
      operationIds: {
        required,
      },
    },
  },
  data() {
    return {
      data_formula: {
        title: '',
        form: null,
        formulaOperationIds: [],
        operationIds: [],
      },
      list_source: [
        {
          id: 1,
          text: 'Field',
          is_delete: false,
        },
        {
          id: 2,
          text: 'Result',
          is_delete: false,
        },
        {
          id: 3,
          text: 'Value',
          is_delete: false,
        },
      ],
      list_operand: [
        {
          id: 1,
          text: '+',
          is_delete: false,
        },
        {
          id: 2,
          text: '-',
          is_delete: false,
        },
        {
          id: 3,
          text: '*',
          is_delete: false,
        },
        {
          id: 4,
          text: ':',
          is_delete: false,
        },
      ],
      list_result: [],
      data_variable: [],
      modeValue: '',
      formulaId: null,
      selectedIndex: 0,
      isResult: false,
    };
  },
  computed: {
    generateDataFormula() {
      const data = {
        info: JSON.stringify({
          formula_id: this.formulaId,
          form_id: this.data_formula.form.id,
          formula_payload: {
            formula_operation_ids: this.data_formula.formulaOperationIds,
            operation_ids: this.data_formula.operationIds,
          },
        }),
        value_id: `${this.formulaId}`,
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_formula.title,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },


    generateDataFormulaUpdate() {
      const data = {
        info: JSON.stringify({
          formula_id: this.formulaId,
          form_id: this.data_formula.form.id,
          formula_payload: {
            formula_operation_ids: this.data_formula.formulaOperationIds,
            operation_ids: this.data_formula.operationIds,
          },
        }),
        value_id: `${this.formulaId}`,
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_formula.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        type_platform: 1,
      };
      return data;
    },
  },
  async mounted() {
    if (this.modeEdit) {
      const formDetail = await this.getDetailForm({
        additional_info_block: {
          id: Number(JSON.parse(this.dataEdit.info).form_id),
        },
      });
      this.data_formula.form = {
        id: formDetail.id,
        name: formDetail.name,
        label: formDetail.name,
      };

      this.data_formula.title = this.dataEdit.name;
      this.formulaId = Number(JSON.parse(this.dataEdit.info).formula_id);

      const param = {
        page: 1,
        limit: 0,
        column: 'id',
        sort: 'asc',
      };

      const dataformulaOps = await this.getFormulaOperationsByFormula({
        formulaId: this.formulaId,
        data: { params: param },
      });

      dataformulaOps.forEach(async (val) => {
        const dataOps = await this.getOperationsByFormulaOperation({
          formulaOpsId: val.id,
          data: { params: param },
        });

        let tempSource = null;
        // let tempRighthand = null;

        if (val.source_type === 2) {
          tempSource = {
            id: val.id,
            text: `${val.source} ${dataOps[0].operation_type} ${dataOps[0].right_hand_operand}`,
            is_delete: false,
          };
        } else {
          tempSource = val.source;
        }

        // if (dataOps[0].right_hand_operand_type === 2) {
        //   tempRighthand = {
        //     id: val.id,
        //     text: `${val.source} ${dataOps[0].operation_type} ${dataOps[0].right_hand_operand}`,
        //     is_delete: false,
        //   };
        // } else {
        //   tempRighthand = dataOps[0].right_hand_operand;
        // }

        this.data_variable.push({
          source: this.list_source.filter(list => list.id === val.source_type)[0],
          operand: this.list_operand.filter(list => list.text === dataOps[0].operation_type)[0],
          righthand: null,
          // righthand_value: tempRighthand,
          source_value: tempSource,
          righthand_value: dataOps[0].right_hand_operand,
          modeSelectOperand: true,
          modeSelectRighthand: true,
          isVariableReady: false,
          isEdit: true,
          isDisabled: true,
          formulaOpsId: val.id,
          opsId: dataOps[0].id,
        });
      });
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent', 'getDetailForm', 'createFormula', 'getFormulaOperationsByFormula', 'createFormulaOperation', 'updateFormulaOperation', 'deleteFormulaOperation', 'getOperationsByFormulaOperation', 'createOperation', 'updateOperation', 'deleteOperation']),

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const reqData = {
            pagination: {
              limit: 50,
              page: 1,
              column: '',
              ascending: true,
              query: searchQuery,
            },
          };
          this.$store.dispatch('jStoreApplication/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    editVariable(index) {
      this.data_variable[index].isVariableReady = true;
      this.data_variable[index].isDisabled = !this.data_variable[index].isDisabled;
    },

    async saveVariable(index) {
      // eslint-disable-next-line camelcase
      const { formulaOpsId, opsId, source_value, righthand_value,
        righthand, source, operand, isEdit } = this.data_variable[index];

      if (!isEdit) {
        const paramFormulaOps = {
          formula_id: this.formulaId,
          source: source.id === 2 ? Number(source_value.id) : Number(source_value),
          source_type: source.id,
          final: 0,
          info: JSON.stringify({ form_id: this.data_formula.form.id }),
        };
        const dataFormulaOps = await this.createFormulaOperation(paramFormulaOps);
        this.data_formula.formulaOperationIds.push(dataFormulaOps.id);
        this.data_variable[index].formulaOpsId = dataFormulaOps.id;

        const paramOperation = {
          formula_id: this.formulaId,
          formula_operation_id: dataFormulaOps.id,
          operation_type: operand.id,
          // eslint-disable-next-line max-len
          right_hand_operand: righthand.id === 2 ? Number(righthand_value.id) : Number(righthand_value),
          right_hand_operand_type: righthand.id,
          info: JSON.stringify({ form_id: this.data_formula.form.id }),
        };
        const dataOps = await this.createOperation(paramOperation);

        this.data_formula.operationIds.push(dataOps.id);
        this.data_variable[index].opsId = dataOps.id;
      } else {
        const paramFormulaOps = {
          formula_id: this.formulaId,
          source: source.id === 2 ? Number(source_value.id) : Number(source_value),
          source_type: source.id,
          final: 0,
          info: JSON.stringify({ form_id: this.data_formula.form.id }),
        };
        this.updateFormulaOperation({ formulaOpsId, data: paramFormulaOps });

        const paramOperation = {
          formula_id: this.formulaId,
          formula_operation_id: formulaOpsId,
          operation_type: operand.id,
          // eslint-disable-next-line max-len
          right_hand_operand: righthand.id === 2 ? Number(righthand_value.id) : Number(righthand_value),
          right_hand_operand_type: righthand.id,
          info: JSON.stringify({ form_id: this.data_formula.form.id }),
        };
        this.updateOperation({ opsId, data: paramOperation });
      }

      this.data_variable[index].isVariableReady = false;
      this.data_variable[index].isDisabled = !this.data_variable[index].isDisabled;
    },

    addVariable() {
      this.data_variable.push({
        source: null,
        operand: null,
        righthand: null,
        source_value: null,
        righthand_value: null,
        modeSelectOperand: false,
        modeSelectRighthand: false,
        isVariableReady: true,
        isEdit: false,
        isDisabled: false,
        formulaOpsId: null,
        opsId: null,
      });
    },

    deleteVariable(index) {
      const text = 'You want to delete this data';

      this.$swal({
        title: 'Are you sure?',
        text,
        type: 'question',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then(async (result) => {
        if (result.value) {
          const { formulaOperationIds, operationIds } = this.data_formula;
          const { formulaOpsId, opsId } = this.data_variable[index];

          if (formulaOpsId) {
            await this.deleteFormulaOperation(formulaOpsId);
            formulaOperationIds.splice(formulaOperationIds.indexOf(formulaOpsId), 1);
          }

          if (opsId) {
            await this.deleteOperation(opsId);
            operationIds.splice(operationIds.indexOf(opsId), 1);
          }

          this.data_variable.splice(index, 1);
        }
      });
    },

    async saveFormulaOperation() {
      this.closeSelectSource();
    },

    async saveOperation() {
      this.closeSelectSource();
    },

    async saveFormula() {
    // this.$v.data_formula.$touch();
    // if (!this.$v.data_formula.$error) {
      if (!this.modeEdit) {
        const paramFormula = {
          name: this.data_formula.title,
        };
        const res = await this.createFormula(paramFormula);
        this.formulaId = res.id;
      }
    },

    finishFormula() {
      if (this.data_formula.formulaOperationIds.length > 0) {
        const lastIndex = this.data_variable.length - 1;
        // eslint-disable-next-line camelcase
        const { formulaOpsId, source_value, source } = this.data_variable[lastIndex];
        const data = {
          formula_id: this.formulaId,
          source: source.id === 2 ? Number(source_value.id) : Number(source_value),
          source_type: source.id,
          final: 1,
          info: JSON.stringify({ form_id: this.data_formula.form.id }),
        };

        this.updateFormulaOperation({ formulaOpsId, data });
      }

      if (!this.modeEdit) {
        const dataParam = {
          data: this.generateDataFormula,
          id: this.dataMaster.id,
        };
        this.saveComponent(dataParam);
      } else {
        const dataParam = {
          data: this.generateDataFormulaUpdate,
          id: this.dataMaster.id,
          component_id: this.dataEdit.id,
        };
        this.updateComponent(dataParam);
      }

      this.closeFormula();
    },

    closeFormula() {
      this.$emit('close-field');
      this.data_formula.title = null;
      this.data_formula.form = null;
      this.formulaId = null;
    },

    closeSelectSource() {
      this.$refs.modalSelectVariableSource.hide();
      this.modeValue = '';
    },

    addOperand(index) {
      this.data_variable[index].modeSelectOperand = true;
    },

    addRighthand(index) {
      this.data_variable[index].modeSelectRighthand = true;
    },

    buttonStyle(data) {
      return data ? 'btn btn-add-additional-info' : 'btn btn-add-additional';
    },

    openModal(index, type) {
      this.selectedIndex = index;
      this.modeValue = type;
      this.$refs.modalSelectVariableSource.show();
      this.checkType(index, type);
    },

    async checkType(index, type) {
      this.isResult = false;
      if (type === 'source' && this.data_variable[index].source) {
        if (this.data_variable[index].source.id === 2) {
          this.list_result = [];
          this.data_variable[index].source_value = null;

          const param = {
            page: 1,
            limit: 0,
            column: 'id',
            sort: 'asc',
          };

          const dataformulaOps = await this.getFormulaOperationsByFormula({
            formulaId: this.formulaId,
            data: { params: param },
          });

          dataformulaOps.forEach(async (val) => {
            const dataOps = await this.getOperationsByFormulaOperation({
              formulaOpsId: val.id,
              data: { params: param },
            });

            this.list_result.push({
              id: val.id,
              text: `${val.source} ${dataOps[0].operation_type} ${dataOps[0].right_hand_operand}`,
              is_delete: false,
            });
          });

          this.isResult = true;
        }
      } else if (type === 'righthand' && this.data_variable[index].righthand) {
        if (this.data_variable[index].righthand.id === 2) {
          this.list_result = [];
          this.data_variable[index].righthand_value = null;

          const param = {
            page: 1,
            limit: 0,
            column: 'id',
            sort: 'asc',
          };

          const dataformulaOps = await this.getFormulaOperationsByFormula({
            formulaId: this.formulaId,
            data: { params: param },
          });

          dataformulaOps.forEach(async (val) => {
            const dataOps = await this.getOperationsByFormulaOperation({
              formulaOpsId: val.id,
              data: { params: param },
            });

            this.list_result.push({
              id: val.id,
              text: `${val.source} ${dataOps[0].operation_type} ${dataOps[0].right_hand_operand}`,
              is_delete: false,
            });
          });

          this.isResult = true;
        }
      }
    },

    sourceOptions(index) {
      if (index === 0) {
        return this.list_source.filter(val => val.id !== 2);
      }
      return this.list_source;
    },

    variableOn(index) {
      // eslint-disable-next-line camelcase
      const { source_value, righthand_value,
        righthand, source, operand, isVariableReady } = this.data_variable[index];

      // eslint-disable-next-line camelcase
      return operand && source_value && righthand_value && source && righthand && isVariableReady;
    },
  },
};
</script>

<style>
.close-button {
  cursor: pointer;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/pages-component/jFormulaSetup.vue